import {
  FeatureSetMap,
  SummaryDisplayFeatureList,
  SummaryFeatureMapItem,
  SummaryFeatureRuleMap,
  FeatureTransformerOptions,
} from '~pricing/lib/summaryPackages';

import { SummaryFeatureTransformer } from '.';

export default function summaryFeaturesTransformer(
  featureListMap: SummaryFeatureMapItem[],
  featureListRules: SummaryFeatureRuleMap
): SummaryFeatureTransformer {
  return (packageFeatures: FeatureSetMap, options: FeatureTransformerOptions): SummaryDisplayFeatureList =>
    featureListMap.map((featureListItem: SummaryFeatureMapItem) => {
      const { featureItemKey }: SummaryFeatureMapItem = featureListItem;
      const featureKeys: string[] = featureListItem.features || [];
      // if the features are empty , push the key inside the feature array based on the rule mapping
      // See src/app/pages/Pricing/transformers/summary/featureRules.ts
      if (!featureKeys.length) {
        featureKeys.push(featureItemKey);
      }
      // map the feature keys with the defined package features
      const featureValues = featureKeys.reduce(
        (acc: FeatureSetMap, featureKey: string) => ({
          ...acc,
          [featureKey]: packageFeatures[featureKey],
        }),
        {}
      );
      // apply the proper rule for this display feature
      return featureListRules[featureItemKey](featureValues, options);
    });
}
